export class Delegation {
  createdAt:        string;
  createdBy:        string;
  delegate:         string;
  fullName:         string;
  delegationParams: DelegationParams;
  delegationUoVo:   DelegationUoVo[] = [];
  deleted:          boolean;
  deletedAt:        Date;
  deletedBy:        string;
  dirSite:          string;
  site:          string;
  function:         string;
  id:               number;
  updatedAt:        Date;
  updatedBy:        string;
}

export class DelegationParams {
  createdAt:   Date;
  createdBy:   string;
  deleted:     boolean;
  deletedAt:   Date;
  deletedBy:   string;
  description: string;
  endDate:     string;
  id:          number;
  label:       string;
  name:        string;
  startDate:   string;
  updatedAt:   Date;
  updatedBy:   string;
}

export class DelegationUoVo {
  createdAt: string;
  createdBy: string;
  deleted:   boolean;
  deletedAt: Date;
  deletedBy: string;
  label:     string;
  name:      string;
  uoId:      string;
  updatedAt: Date;
  updatedBy: string;
}



// WEBPACK FOOTER //
// ./src/app/model/delegation.ts